import React from 'react'
import Icon from 'blocks.simple/icon/icon'
import translate from 'core/translate'
import { cn } from 'ethcss'
import { secondFactorActionStyles as styles } from './SecondFactorAction-styles'

export type SecondFactorStepperIndex = 1 | 2 | 3

type Props = {
    active: SecondFactorStepperIndex
}

export function SecondFactorActionStepper({ active }: Props) {
    const items: Array<{ index: SecondFactorStepperIndex; label: string }> = [
        { index: 1, label: translate('secondFactorStepProof') },
        { index: 2, label: translate('secondFactorStepQr') },
        { index: 3, label: translate('secondFactorStepRecovery') },
    ]

    return (
        <div className={styles.stepper}>
            {items.map((item, i) => {
                const done = active > item.index
                const current = active === item.index
                return (
                    <React.Fragment key={item.index}>
                        {i > 0 ? <div className={cn(styles.stepTail, done && styles.stepTailDone)} /> : null}
                        <div className={styles.stepItem}>
                            <div
                                className={cn(
                                    styles.stepBadge,
                                    current && styles.stepBadgeCurrent,
                                    done && styles.stepBadgeDone
                                )}
                            >
                                {done ? <Icon type="checked" size={14} color="white" /> : item.index}
                            </div>
                            <div className={cn(styles.stepLabel, (current || done) && styles.stepLabelActive)}>
                                {item.label}
                            </div>
                        </div>
                    </React.Fragment>
                )
            })}
        </div>
    )
}
